import React from 'react';
import { Field } from 'redux-form';
import { hasPermission } from '../../../../auth/redux/authActions';
import PremiumAdjustSliders from '../../PremiumAdjustSliders/PremiumAdjustSliders';

const PremiumAdjust = ({
  isMta,
  isCalculating,
  selectedScheme,
  handleCommissionAdjustments,
}) => {
  if (
    isMta ||
    !selectedScheme ||
    !hasPermission('policy.premium_overrides_gross') ||
    isCalculating
  ) {
    return null;
  }

  const ownerCommission = selectedScheme.commissions.find(
    (commission) => commission.commission_type === 'owner',
  );
  const brokerCommission = selectedScheme.commissions.find(
    (commission) => commission.commission_type === 'broker',
  );
  const initialCommissions = {};
  const currentCommissions = {};
  if (ownerCommission) {
    initialCommissions.commission_owner =
      (ownerCommission.original_rate || ownerCommission.rate) * 100;
    currentCommissions.commission_owner =
      (ownerCommission.effective_rate || ownerCommission.rate) * 100;
  }
  if (brokerCommission) {
    initialCommissions.commission_broker =
      (brokerCommission.original_rate || brokerCommission.rate) * 100;
    currentCommissions.commission_broker =
      (brokerCommission.effective_rate || brokerCommission.rate) * 100;
  }

  return (
    <Field
      name={'data.attributes.metadata.overrides'}
      handleCommissionAdjustments={handleCommissionAdjustments}
      premiumIndication={selectedScheme}
      selectedScheme={selectedScheme}
      isCalculating={isCalculating}
      component={PremiumAdjustSliders}
      initialCommissions={initialCommissions}
      currentCommissions={currentCommissions}
    />
  );
};

export default PremiumAdjust;
